import axios from "axios";

export const API = "/api";

export const api = axios.create({ baseURL: API, withCredentials: true });

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export function inr(n) {
  if (n == null) return "";
  return `₹${Number(n).toLocaleString("en-IN")}`;
}

export function priceLabel(service) {
  if (!service) return "";
  if (service.price_type === "custom" || service.price == null) return "Custom Quote";
  const base = inr(service.price);
  return service.price_type === "starting" ? `Starting ${base}` : base;
}
